<script>
import ieVerify from '@/views/cargo/v0/Integrated/ieVerify'

export default {
  name: 'CLIEVerify',
  extends: ieVerify,
  props: {
    integratedLogisticsType: {
      type: String,
      default: 'CL' // 设置默认值
    }
  }
}
</script>
